export default function() {
  return data;
}
let data = {
  zoneOne: {
    img: "smart-utilities-depth.webp",
    imgTwo: "smart-utilities-depth.png",
    size: { width: 32, height: 36.3 },
    position: { x: -0.4, y: 59.5 }
  },
  zoneTwo: {
    img: "energy-efficiency.webp",
    imgTwo: "energy-efficiency.png",
    size: { width: 23, height: 18.55 },
    position: { x: 7.5, y: 43.2 }
  },
  zoneThree: {
    img: "smart-infrastructure-depth1.webp",
    imgTwo: "smart-infrastructure-depth1.png",
    size: { width: 25.95, height: 26 },
    position: { x: 22.065, y: 44.5 }
  },
  zoneFour: {
    img: "proactive-transport.webp",
    imgTwo: "proactive-transport.png",
    size: { width: 55, height: 37 },
    position: { x: 57.4, y: 57.3 }
  },
  zoneFive: {
    img: "reduce-congestion-depth.webp",
    imgTwo: "reduce-congestion-depth.png",
    size: { width: 45, height: 32 },
    position: { x: 73, y: 43.5 }
  },
  zoneSix: {
    img: "improve-supply-chain.webp",
    imgTwo: "improve-supply-chain.png",
    size: { width: 40, height: 34 },
    position: { x: 100, y: 50.4 }
  },
  zoneSeven: {
    img: "reduce-downtime-depth1.webp",
    imgTwo: "reduce-downtime-depth1.png",
    size: { width: 18.8, height: 14.5 },
    position: { x: 100, y: 48.4 }
  },
  zoneEight: {
    img: "promote-wellness-depth1.webp",
    imgTwo: "promote -wellness-depth1.png",
    size: { width: 27.3, height: 26 },
    position: { x: 32.8, y: 39.93 }
  },
  zoneNine: {
    img: "equipmnet-tracking-depth.webp",
    imgTwo: "equipmnet-tracking-depth.png",
    size: { width: 27.6, height: 22 },
    position: { x: 53.99, y: 31.6 }
  },
  zoneTen: {
    img: "customer-lyalty-depth.webp",
    imgTwo: "customer-lyalty-depth.png",
    size: { width: 22.4, height: 16.7 },
    position: { x: 69.86, y: 35.38 }
  },
  zoneEleven: {
    img: "maritime_scene.webp",
    imgTwo: "maritime_scene.png",
    size: { width: 50, height: 38 },
    position: { x: 4, y: 74 }
  },
  zoneTwelve: {
    img: "surveillance_scene.webp",
    imgTwo: "surveillance_scene.webp",
    size: { width: 26, height: 21 },
    position: { x: 92, y: 39 }
  }
};
